// extracted by mini-css-extract-plugin
module.exports = {"color-concrete":"#F2F2F2","colorConcrete":"#F2F2F2","medium":"only screen and (min-width: 768px)","tabSwitcher":"_3_wDA","overflowContainer":"_1BTvr","tabs":"ptFum"};